export default "__VITE_ASSET__C5xQQVAd__ 100w";